<template>
	<v-dialog v-model="showDialog" max-width="560px" persistent>
		<v-card>
			<v-card-title>
				<span class="text-h5">Generate unlock code</span>
			</v-card-title>
			<v-card-text>
				<p class="mb-4">
					An unlock code lets a user get back into Iris Mobile in the
					field with no network connection. Read it out to them over
					the phone; it only works for this project.
				</p>
				<v-form ref="form">
					<v-menu
						v-model="showPicker"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="expiresOn"
								label="Unlock the app until"
								prepend-icon="mdi-calendar"
								readonly
								:rules="expiresOnRules"
								v-bind="attrs"
								v-on="on"
							/>
						</template>
						<v-date-picker
							v-model="expiresOn"
							:min="minDate"
							@input="showPicker = false"
						/>
					</v-menu>
				</v-form>

				<v-alert v-if="generatedCode" type="success" text class="mt-4">
					<div class="mb-2">
						Read this code to the user. It is also listed below and
						can be revoked at any time.
					</div>
					<div class="d-flex align-center">
						<span class="mobile-access-code">{{
							generatedCode.Code
						}}</span>
						<v-btn
							icon
							class="ml-2"
							title="Copy to clipboard"
							@click="copyCode"
						>
							<v-icon>mdi-content-copy</v-icon>
						</v-btn>
					</div>
				</v-alert>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn text outlined @click="onClose">Close</v-btn>
				<v-btn color="primary" @click="onGenerate">
					<v-icon class="mr-2">mdi-key-variant</v-icon>
					Generate
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
	export default {
		name: 'MobileAccessCodeDialog',
		props: {
			showDialog: {
				type: Boolean,
				default: false,
			},
			projectId: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				expiresOn: null,
				showPicker: false,
				generatedCode: null,
				expiresOnRules: [(v) => !!v || 'An expiry date is required'],
			};
		},
		computed: {
			minDate() {
				return new Date().toISOString().substring(0, 10);
			},
		},
		methods: {
			onGenerate() {
				if (!this.$refs.form.validate()) return;
				this.$emit('generate', {
					ProjectId: this.projectId,
					ExpiresOn: this.expiresOn,
				});
			},
			// Called by the parent once the server has returned the code.
			setGeneratedCode(code) {
				this.generatedCode = code;
			},
			copyCode() {
				if (!this.generatedCode) return;
				navigator.clipboard.writeText(this.generatedCode.Code);
			},
			onClose() {
				this.generatedCode = null;
				this.expiresOn = null;
				this.$emit('close');
			},
		},
	};
</script>
<style scoped>
	.mobile-access-code {
		font-family: monospace;
		font-size: 1.6rem;
		letter-spacing: 0.15rem;
		font-weight: 600;
	}
</style>
